module.exports = __webpack_public_path__ + "assets-cabinet/img/phone-incoming.e36e2cb1.svg";